import React, { useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Button, Col, Form, Row } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";
import { BsArrowDown, BsDownload } from "react-icons/bs";
import { FaArchive } from "react-icons/fa";
import { saveAs } from "file-saver";
import funcionalidades from "../../../context/AuthContext.funcionalidades";
import useApiClient, { apiRoutes } from "../../../hooks/apiClient";
import ButtonImagePermission from "../Button/ButtonImagePermission";
import EfisModalJustificativa from "../EfisModal/EfisModalJustificativa";
import TextSpinner from "../Spinner/TextSpinner";
import Base64ToBlob from "../../Formatters/Base64ToBlob";
import FileDownloader from "../Button/FileDownloader";
import useDocumentoParteServico from "../../../pages/OS/ParteServico/hooks/useDocumentoParteServico";
import constants from "../../../pages/Constants";

const documentoParteServico = { exibir: () => {} };
const documentoDenuncia = { exibir: () => {} }; // ainda não implementado
const documentoCobrança = { exibir: () => {} }; // ainda não implementado

const exibirDocumento = (origem, sequence) => {
  if (origem === "P") {
    documentoParteServico.exibir(sequence);
  } else if (origem === "D") {
    documentoDenuncia.exibir(sequence);
  } else {
    documentoCobrança.exibir(sequence);
  }
};

const downloadCell = (row, title, tipoOrigem, setShowCancelaConfirm, handleBaixarDocumento) => (
  <>
    {row.documento && <FileDownloader binario={row.documento} tooltip={`Visualizar Documento ${row.sequencial}`} />}

    {!row.documento && tipoOrigem !== "P" && (
      <ButtonImagePermission
        permission={funcionalidades.spf.download}
        className="btn-lg text-success pa-0 p-0"
        buttonImage={<BsDownload size="16" color="#e37023" />}
        tooltipImage={`Visualizar Documento ${row.sequencial}`}
        onClick={() => handleBaixarDocumento(row.sequencial, tipoOrigem)}
      />
    )}

    {!row.documento && tipoOrigem === "P" && (
      <ButtonImagePermission
        permission={funcionalidades.spf.download}
        className="btn-lg text-success pa-0 p-0"
        buttonImage={<BsDownload size="16" color="#e37023" />}
        tooltipImage={`Visualizar Documento ${row.sequencial}`}
        onClick={() => exibirDocumento(tipoOrigem, row.sequencial)}
      />
    )}

    <ButtonImagePermission
      permission={funcionalidades.spf.inserir}
      className="btn pa-0 p-0 px-1"
      onClick={() => {
        setShowCancelaConfirm({
          show: true,
          codigo: row.sequencial,
          situacao: tipoOrigem,
          body: `Encerrar  ${title}: ${row.sequencial}`,
        });
      }}
      buttonImage={<FaArchive />}
      tooltipImage="Encerrar"
    />
  </>
);

const OrigemSpfPaginatedView = ({
  columns: propsColumns,
  title,
  keyField,
  defaultSearch,
  defaultSearchPlaceholder,
  advancedParameters: propsAdvancedParameters,
  queryService,
  history,
  editRoute,
  expandComponent,
}) => {
  const [rows, setRows] = useState([]);
  const [pageSize] = useState(25);
  // const [totalRows, setTotalRows] = useState(0);
  // const [pageSize, setPageSize] = useState(25);
  const [pageNumber, setPageNumber] = useState(1);
  const [inputSearchArgument, setInputSearchArgument] = useState("");
  const [searchParameters, setSearchParameters] = useState({});
  const [showCancelaConfirm, setShowCancelaConfirm] = useState({
    show: false,
    codigo: 0,
    situacao: "",
    body: null,
  });
  const [tipoDocumento, setTipoDocumento] = useState("");
  const [sequencial, setSequencial] = useState();
  const advancedParameters = propsAdvancedParameters;
  const columns = [...propsColumns];

  const { setDocParams } = useDocumentoParteServico();

  documentoParteServico.exibir = (sqParteServico) => {
    setDocParams({ sqParteServico });
  };

  const { request, isLoading, data, errors } = useApiClient();

  const {
    request: cancelaItemRequest,
    isLoading: cancelaItemIsLoading,
    data: cancelaItemData,
    errors: cancelaItemErrors,
  } = useApiClient();

  const { request: requestDownload, data: dataDownload, errors: errorDownload } = useApiClient();

  useEffect(() => {
    let nomeDocumento;
    let file;

    if (dataDownload) {
      if (tipoDocumento === "D") {
        nomeDocumento = `denuncia-${sequencial}.pdf`;
      } else if (tipoDocumento === "C") {
        nomeDocumento = `cobranca-${sequencial}.html`;
      } else if (tipoDocumento === "P") {
        nomeDocumento = `parte-servico-${sequencial}.pdf`;
      }

      if (tipoDocumento === "D") {
        file = new Blob([dataDownload], { type: "application/pdf" });
      } else if (tipoDocumento === "P") {
        const byteArray = Base64ToBlob(dataDownload.result[0]?.documento);
        file = new Blob([byteArray], { type: "application/pdf" });
      } else {
        file = new Blob([dataDownload], { type: "application/html" });
      }

      if (tipoDocumento === "D") {
        const url = URL.createObjectURL(file);
        window.open(url, "", "width=800,height=800").print();
      } else {
        saveAs(file, nomeDocumento);
      }
    }

    if (errorDownload) {
      toast.error(errorDownload.message);
    }
  }, [dataDownload, errorDownload, sequencial, tipoDocumento]);

  const handleBaixarDocumento = useCallback(
    (sequencialDocumento, tipo) => {
      if (tipo === "D") {
        const params = { sqDenuncia: sequencialDocumento };
        requestDownload(apiRoutes.fiscalizacao.procedimentoFiscal.downloadDenuncia, params);
      } else if (tipo === "C") {
        const params = { sqCobranca: sequencialDocumento };
        requestDownload(apiRoutes.fiscalizacao.procedimentoFiscal.downloadCobranca, params);
      } else if (tipo === "P") {
        const params = { numParteServico: sequencialDocumento };
        requestDownload(apiRoutes.fiscalizacao.parteservico.listaParteServico, params);
      }
      setTipoDocumento(tipo);
      setSequencial(sequencialDocumento);
    },
    [requestDownload, setTipoDocumento, setSequencial],
  );

  useEffect(() => {
    request(queryService, {
      ...advancedParameters,
      ...searchParameters,
      pageSize,
      pageNumber,
    });
  }, [request, queryService, advancedParameters, searchParameters, pageSize, pageNumber]);

  useEffect(() => {
    if (data && data.result) {
      if (data.result.length && !data.result[0].totalRows) {
        console.error(`[DEV] A propriedade "totalRows" é obrigatória nos resultados paginados. `);
        return;
      }
      setRows(data.result || []);
      // setTotalRows(data.result.length ? data.result[0].totalRows : 0);
    }

    if (errors) {
      toast.error(errors.message);
    }
  }, [data, errors]);

  const refreshItems = useCallback(() => {
    window.location.reload(false);
  }, []);

  useEffect(() => {
    if (!cancelaItemData && !cancelaItemErrors) return;

    if (cancelaItemData) {
      toast.success("Cancelamento realizado com sucesso. ");
      refreshItems(null);
    }

    if (cancelaItemErrors) {
      toast.error(cancelaItemErrors.message);
    }

    setShowCancelaConfirm({ show: false });
  }, [cancelaItemData, cancelaItemErrors, refreshItems, setShowCancelaConfirm]);

  columns.push({
    name: "Ações",
    cell: (row) =>
      downloadCell(row, title, advancedParameters.tipoOrigem, setShowCancelaConfirm, handleBaixarDocumento),
    maxWidth: "130px",
    center: true,
  });

  return (
    <>
      <EfisModalJustificativa
        show={showCancelaConfirm.show}
        title={showCancelaConfirm.title}
        body={showCancelaConfirm.body}
        codigo={showCancelaConfirm.codigo}
        situacao={showCancelaConfirm.situacao}
        loadingConfirmationAction={cancelaItemIsLoading}
        closeHandler={() => setShowCancelaConfirm({ show: false })}
        confirmationHandler={(codigo, situacao, texto) => {
          cancelaItemRequest(apiRoutes.fiscalizacao.procedimentoFiscal.cancelaOrigem, {
            sequencial: codigo,
            tipoOrigem: situacao,
            justificativa: texto,
          });
        }}
      />

      <div className="row">
        <div className="col-lg-12">
          <div className="card shadow mb-4">
            {defaultSearch && (
              <div className="card-header pt-3 pb-0 flex-row w-100">
                <Form.Group as={Row} className="d-flex flex-row">
                  <Col sm="12" className="form-inline justify-content-end">
                    <Form.Control
                      className="w-auto mr-0"
                      type="text"
                      placeholder={defaultSearchPlaceholder}
                      value={inputSearchArgument}
                      onChange={(e) => setInputSearchArgument(e.target.value)}
                    />
                    <Button
                      className="mr-0 btn btn-primary btn-md btn-user mx-4"
                      onClick={() => {
                        setPageNumber(1);
                        setSearchParameters({ searchArgument: inputSearchArgument });
                      }}
                    >
                      Buscar
                    </Button>
                  </Col>
                </Form.Group>
              </div>
            )}
            <div className="card-body">
              <DataTable
                noHeader
                keyField={keyField}
                columns={columns}
                data={rows}
                progressPending={isLoading}
                noDataComponent="Nenhum registro para exibir"
                progressComponent={<TextSpinner />}
                pagination
                paginationComponentOptions={constants.paginationComponentOptions}
                sortable
                sortIcon={<BsArrowDown />}
                selectableRows={false}
                pointerOnHover
                onRowClicked={(item) => {
                  history.push({
                    pathname: editRoute,
                    state: {
                      sequencialOrigem: item[keyField],
                      tipoOrigem: advancedParameters.tipoOrigem,
                      documento: item.inscricaoEstadual ? item.inscricaoEstadual : item.cpfCnpj,
                      row: item,
                    },
                  });
                }}
                expandableRows={expandComponent}
                expandableRowsComponent={expandComponent}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

OrigemSpfPaginatedView.propTypes = {
  keyField: PropTypes.string.isRequired,
  editRoute: PropTypes.string.isRequired,
};

export default OrigemSpfPaginatedView;
